<!--ライブボタン切替テーブルと確認ダイアログのコンポーネントです。-->
<template>
  <Loading v-if="loading"></Loading>
  <div v-else id="app">
    <div class="table-responsive">
      <table id="control_table" class="table table-bordered">
        <thead>
          <tr id="control_table_label" class="control_table_row">
            <th class="room">会議室</th>
            <th class="btnstate" colspan="2">ライブボタン状態</th>
            <th class="twolines">ライブ<br />再生ページ</th>
            <th class="datename">開催日・会議名</th>
            <th class="twolines">公開サイト<br />トップ</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, key) in eventinfo"
            :key="key"
            v-bind:class="{ live_valid: item.eventActivePublic }"
          >
            <td class="text-left">
              {{ item.roomLabel }}　({{ item.roomTitle }})
            </td>
            <td class="status text-center">
              <span v-if="item.eventActivePublic" class="valid bold"
                >有効 <img src="./icons/camera-video.svg" alt="video-on"
              /></span>
              <span v-else
                >無効
                <img src="./icons/camera-video-off.svg" alt="video-off" />
              </span>
            </td>
            <td class="control text-center">
              <v-btn
                v-if="item.eventActivePublic"
                type="button"
                class="control_button btn btn-secondary"
                v-on:click="liveOff(item)"
              >
                無効にする
              </v-btn>
              <v-btn
                v-else
                type="button"
                class="control_button btn btn-primary"
                v-on:click="liveOn(item)"
                data-bs-toggle="modal"
                data-bs-target="#controlModal"
              >
                有効にする
              </v-btn>
            </td>
            <td class="preview">
              <form
                name="{{item.roomId}}"
                action=""
                method="post"
                target="_blank"
              >
                <input type="hidden" name="AccessToken" value="" />
              </form>
              <a
                title="再生ページを表示します"
                href="javascript:void(0);"
                @click="openLivePage(item)"
                class="preview_link"
              >
                <img src="./icons/front.svg" alt="再生ページを表示します" />
              </a>
            </td>
            <td class="event text-left">
              {{ formatDate(item.eventDate) }}
              <br />{{ item.eventSeriesLabel }}
            </td>
            <td class="preview">
              <a
                title="公開サイトを表示します"
                href="javascript:void(0);"
                v-on:click="openTopPage(item)"
                class="preview_link"
              >
                <img src="./icons/front.svg" alt="公開サイトを表示します" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ダイアログ -->
    <div
      class="modal fade"
      id="controlModal"
      tabindex="-1"
      aria-labelledby="controlModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="controlModalLabel">確認</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-left">
            会議室： {{ modalitem.roomLabel }}　({{
              modalitem.roomTitle
            }})<br />

            開催日： {{ formatDate(modalitem.eventDate) }}<br />
            会議名： {{ modalitem.eventSeriesLabel }}<br />

            <div v-if="this.date != modalitem.eventdate" class="mt-2 mb-2">
              <span class="text-dark fw-bold bg-primary bg-opacity-10">
                <img
                  src="./icons/exclamation-triangle-fill.svg"
                  alt="exclamation" />
                この会議室に割り当てられている会議は、本日開催の会議ではありません。<br
              /></span>
            </div>
            ライブボタンを
            <span class="text-primary fw-bold">有効</span> にします。<br />
            続行しますか？<br />
          </div>
          <div class="modal-footer">
            <v-btn
              v-on:click="flagUpdate"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              はい
            </v-btn>
            <v-btn
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              いいえ
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CMethod from "@/lib/CommonMethods";
import Loading from "../Common/Loading.vue";
import LiveBtnControl from "../../views/LiveBtnControl.vue";
import store from "@/store/index.js";

export default {
  components: { Loading, LiveBtnControl },
  data() {
    return {
      loading: true,
      eventinfo: [],
      modalitem: [],
      select: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    /**
     * 再生ページリンク押下時処理
     * ボタン状態に応じて本番ページor事前確認ページへ遷移します。
     */
    openLivePage(e) {
      // ボタン状態に応じて遷移先を制御
      if (e.eventActivePublic) {
        window.open(
          store.getters.publicUrl + "?tpl=play_live&room_id=" + e.roomId,
          "_blank"
        );
      } else {
        document.forms[e.roomId].AccessToken.value = store.getters.token;
        document.forms[e.roomId].action =
          store.getters.privateUrl + "?tpl=play_live&room_id=" + e.roomId;
        document.forms[e.roomId].submit();
      }
    },

    /**
     * トップページリンク押下時処理
     * トップページに遷移します。
     */
    openTopPage() {
      window.open(store.getters.publicUrl, "_blank");
    },

    /**
     * 有効/無効ボタン押下時処理
     * ボタン状態を有効にします。
     */
    liveOn(e) {
      this.select = e;
      this.modalitem = e;
    },

    /**
     * 有効/無効ボタン押下時処理
     * ボタン状態を無効にします。
     */
    liveOff(e) {
      this.select = e;
      this.flagUpdate();
    },

    /**
     * ボタン状態および登録値を更新します。
     */
    async flagUpdate() {
      // 状態変更
      this.select.eventActivePublic = !this.select.eventActivePublic;

      //要求（イベントIDと制御フラグを送信）
      const body = [
        {
          eventId: this.select.eventId,
          eventActivePublic: this.select.eventActivePublic,
        },
      ];

      var result = await this.$StarkManager.getMember("Morgan").postEvent(body);

      // 更新失敗時
      if (result != "OK") {
        // 状態を戻す
        this.select.eventActivePublic = !this.select.eventActivePublic;
        alert("ライブボタンの変更ができませんでした。");
      }
    },
    /**
     * 日付フォーマットを変更します。
     */
    formatDate(date) {
      return CMethod.formatDate(date);
    },
    /**
     * ページ表示時初期処理
     * ライブイベント一覧を取得します。
     */
    async getEvent() {
      var response = await this.$StarkManager.getMember("Morgan").getEvent();
      this.loading = false;
      this.eventinfo = response.data;
    },
  },
  mounted() {
    // ライブイベント一覧取得
    this.getEvent();
  },
};
</script>

<style>
/** テーブル  */
#control_table {
  width: 70%;
  margin: 20px;
}

/** テーブル列幅  */
.room {
  width: 33%;
}

.btnstate {
  width: 17%;
}

.twolines {
  width: 10%;
}

.datename {
  width: 25%;
}

/** 状態セル */
.status {
  width: auto;
  width: 2.5em;
  white-space: nowrap;
}

button.control_button {
  font-size: 13px;
}

.event {
  white-space: nowrap;
}

.live_valid {
  font-weight: bold;
  background-color: #e6f1ff;
}

.valid {
  color: blue;
}

.bold {
  font-weight: bold;
}

.hidden {
  display: none;
}

.modal-open {
  padding-right: 0 !important;
}
</style>
